var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-demo"},[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"m-left"},[_c('div',{ref:"playerTemp",staticClass:"player-olympic",on:{"click":_vm.videoBarChange}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }